import { render, staticRenderFns } from "./PerformanceReviewItemBuilder.vue?vue&type=template&id=18996739&scoped=true&"
import script from "./PerformanceReviewItemBuilder.vue?vue&type=script&lang=js&"
export * from "./PerformanceReviewItemBuilder.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceReviewItemBuilder.vue?vue&type=style&index=0&id=18996739&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18996739",
  null
  
)

export default component.exports